"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagerDutyTestEventStepSchema = exports.PagerDutyRoutingKeySchema = exports.PagerDutyRegionSchema = void 0;
exports.maskPagerDutyRoutingKey = maskPagerDutyRoutingKey;
const zod_1 = require("zod");
/** PagerDutyRegionSchema is the service region of a PagerDuty account; it picks the Events API host. */
exports.PagerDutyRegionSchema = zod_1.z.enum(["US", "EU"]);
/**
 * PagerDutyRoutingKeySchema accepts an Events API v2 routing key: a service
 * integration key or an Event Orchestration key. PagerDuty issues both as 32
 * alphanumeric characters.
 */
exports.PagerDutyRoutingKeySchema = zod_1.z
    .string()
    .trim()
    .regex(/^[A-Za-z0-9]{32}$/, "Routing key must be the 32-character integration key from PagerDuty");
/** PagerDutyTestEventStepSchema is a step of the test alert: trigger it at critical severity, or resolve it. */
exports.PagerDutyTestEventStepSchema = zod_1.z.enum(["trigger", "resolve"]);
/** maskPagerDutyRoutingKey keeps the first and last four characters, e.g. `R0ab...9xYz`. */
function maskPagerDutyRoutingKey(routingKey) {
    if (routingKey.length <= 8)
        return "...";
    return `${routingKey.slice(0, 4)}...${routingKey.slice(-4)}`;
}
